const modelTransformer = require('./model');
const leaseTransformer = require('./lease');
const leadSchema = require('./leadSchema');
const eqLvlTransformer = require('./equipmentLevel').default;
const variantTransformer = require('./variant');
const equipmentTransformer = require('./equipment');
const equipmentFactoryTransformer = require('./equipmentFactory');
const equipmentLevelTransformer = require('./equipmentLevel');
const assetTransformer = require('./asset');
const isResolvedResource = require('../contentful/is-resolved-resource');



module.exports = {
  contentfulToInternal(entry) {
    // console.log("Entry", entry);
    const result = {
      id: entry.sys.id,
      published: Boolean(entry.sys.publishedVersion),
      updated: entry.sys.publishedVersion && entry.sys.version > entry.sys.publishedVersion + 1,
      draft: !entry.sys.publishedVersion,
      archived: Boolean(entry.sys.archivedVersion),
      contentType: entry.sys.contentType.sys.id,

      title: '',
      description: ''
    };

    // TODO: Do this for all known contentTypes
    if (result.contentType === 'lease') {
      return leaseTransformer.contentfulToInternal(entry);
    }

    if (result.contentType === 'variant') {
      return variantTransformer.contentfulToInternal(entry);
    }

    if (result.contentType === 'leadSchema') {
      return leadSchema.contentfulToInternal(entry);
    }

    if (entry.fields.displayname && entry.fields.displayname['nb-NO']) {
      result.title = entry.fields.displayname['nb-NO'];
    } else if (entry.fields.title && entry.fields.title['nb-NO']) {
      result.title = entry.fields.title['nb-NO'];
    } else if (entry.fields.name && entry.fields.name['nb-NO']) {
      result.title = entry.fields.name['nb-NO'];
    }

    if (entry.fields.description && entry.fields.description['nb-NO']) {
      result.description = entry.fields.description['nb-NO'];
    }

    switch (result.contentType) {
      case 'color':
        // Color specific stuff
        result.model = null;
        result.type = null;
        result.priceAdjustment = null;
        result.eqLevel = null;
        if (entry.fields.model && entry.fields.model['nb-NO']) {
          result.model = modelTransformer.contentfulToInternal(entry.fields.model['nb-NO']);
        }
        if (entry.fields.type && entry.fields.type['nb-NO']) {
          result.type = entry.fields.type['nb-NO'];
        }
        if (entry.fields.priceAdjustment && entry.fields.priceAdjustment['nb-NO']) {
          result.priceAdjustment = entry.fields.priceAdjustment['nb-NO'];
        }
        if (entry.fields.equipmentLevelWhitelist && entry.fields.equipmentLevelWhitelist['nb-NO']) {
          result.equipmentLevelWhitelist = entry.fields.equipmentLevelWhitelist['nb-NO'].map(eqLvlTransformer.contentfulToInternal);
        }
        if (entry.fields.mainImage && entry.fields.mainImage['nb-NO'] && isResolvedResource(entry.fields.mainImage['nb-NO'])) {
          result.mainImage = assetTransformer.contentfulToInternal(entry.fields.mainImage['nb-NO']);
        }
        break;
      case 'variant':
        if (entry.fields.equipmentLevel && entry.fields.equipmentLevel['nb-NO'] && isResolvedResource(entry.fields.equipmentLevel['nb-NO'])) {
          result.equipmentLevel = equipmentLevelTransformer.contentfulToInternal(entry.fields.equipmentLevel['nb-NO']);
        }
        break;
      case 'equipment':
        return equipmentTransformer.contentfulToInternal(entry);
      case 'equipmentFactory':
        return equipmentFactoryTransformer.contentfulToInternal(entry);
    }

    return result;
  }
};
